import { openSearchDatasets, registerOpenSearchDatasets } from './dataset-utils.ts';
import { searchDatasetsRequest } from 'tio-data/requests/search-datasets';
import type { Store as StoreService } from '@warp-drive/core';

/**
 * Fetch the user-scoped OpenSearch dataset catalog and fill the registry the
 * synchronous dataset-utils lookups read. Shared by every route that hosts a
 * query-capable reporting surface, so a fresh-session deep link into any of
 * them sees the same catalog.
 *
 * Never throws: a failed fetch keeps the last-known-good registry rather than
 * rerouting already-open reports mid-session. Returns whether the registry
 * holds a usable catalog — callers must not register SQL datasets when it does
 * not, because a SQL slug colliding with a classic dataset key would then pass
 * the reserved-key guard and reroute that dataset to sql-search.
 */
export async function registerOpenSearchDatasetCatalog(store: StoreService): Promise<boolean> {
  try {
    const { content } = (await store.request(searchDatasetsRequest())) as {
      content: {
        availableDatasets: Array<{
          slug: string;
          label: string;
          modelType: string;
          product: string;
        }>;
      };
    };
    registerOpenSearchDatasets(content.availableDatasets);
  } catch (error) {
    console.error('Failed to load the OpenSearch dataset catalog for Report Builder:', error);
  }

  return openSearchDatasets().length > 0;
}
